"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blobToBase64 = function (blob) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () {
            // @ts-ignore
            var base64String = reader === null || reader === void 0 ? void 0 : reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
exports.default = blobToBase64;
